// extracted by mini-css-extract-plugin
module.exports = {"skipLink":"skip-link-module--skip-link--1AfTc"};